import { render, staticRenderFns } from "./scanBookEditor.vue?vue&type=template&id=0df59824&"
import script from "./scanBookEditor.vue?vue&type=script&lang=js&"
export * from "./scanBookEditor.vue?vue&type=script&lang=js&"
import style0 from "./scanBookEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports